import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import AdminGateway from '~apis/admin';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetUserDetails(api: AdminGateway): SagaWatcherReturnType {
    yield takeEvery('auth/authGetUserDetailsAttempt', handleGetUserDetails, api);
}

function* handleGetUserDetails(api: AdminGateway) {
    const authToken = store.getState().auth.userDetails.authToken;

    const response = yield* call([api, api.getUserDetails], { authToken });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.authGetUserDetailsFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        const { data: responseData } = response;

        yield put(combinedActions.authGetUserDetailsSuccess(
            {
                authToken,
                ...responseData,
            }
        ));
    }
}
